<template>
    <v-card class="elevation-1 rounded-4"> 
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">{{ popupTitle }}</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-xs-center">
            <p v-html="msg" :class="alignLeft?'msg-text-left':'msg-text'"></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn title="Ok" class="primary" dark @click="ok" :loading="loading">Ok</v-btn>
            <v-btn title="Cancel" @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
        }
    },
    props:['msg', 'alignLeft', 'title'],
    methods: {
        ok() {
            this.closeDialog()
            this.$emit('ok', null)
        },
        closeDialog() {
            this.$emit('update:dialogOkCancel', false)
        },
    },
    created() {},
    computed: {
        popupTitle() {
            return this.title ? this.title : 'Confirm'
        }
    },
}
</script>
<style scoped>
.msg-text {
    margin:10px 20px 10px 20px;
}
.msg-text-left {
    margin:10px 20px 10px 20px;
    text-align: left;
}
</style>